import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-common-comparisons",
  "use": "svg-icon-common-comparisons-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"svg-icon-common-comparisons\"><path fill=\"#f9ab1a\" d=\"M24 31.178h52v9.594H24zm0 14.025h35.53v9.594H24zm0 14.025h19.06v9.594H24z\" /><path fill=\"#fff\" d=\"M43.06 59.228H76v9.594H43.06zm16.47-14.01H76v9.594H59.53z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol